import Heading from './Heading';

import './Heading.scss';

export default Heading;
